export default __webpack_public_path__ + "alberta-icon.a2b7a4cdeeeaabcf8c48.svg";